import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import {
  CreateFollowUpRequest,
  FollowUp,
  FollowUpUpdateModel,
} from "../models/FollowUpModels";
import { PagedResult } from "../models/PagedModels";

const API_BASE_URL = Constants.API_BASE_URL;

export interface FollowUpListQuery {
  page?: number;
  pageSize?: number;
  status?: number;
  search?: string;
  isDue?: boolean;
  dueFrom?: string;
  dueTo?: string;
  uniquePhone?: boolean;
}

export async function getFollowUpsByOrganizationAsync(
  token: string,
  organizationId: string,
  query: FollowUpListQuery = {},
): Promise<ResponseMessage<PagedResult<FollowUp>>> {
  const response = await axios.get(
    `${API_BASE_URL}/followups/organization/${organizationId}`,
    {
      params: {
        page: query.page,
        pageSize: query.pageSize,
        status: query.status,
        search: query.search,
        isDue: query.isDue,
        dueFrom: query.dueFrom,
        dueTo: query.dueTo,
        uniquePhone: query.uniquePhone,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function createFollowUpAsync(
  token: string,
  request: CreateFollowUpRequest,
): Promise<ResponseMessage<FollowUp>> {
  const response = await axios.post(`${API_BASE_URL}/followups`, request, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function updateFollowUpAsync(
  token: string,
  id: string,
  model: FollowUpUpdateModel,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.put(`${API_BASE_URL}/followups/${id}`, model, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}

export async function deleteFollowUpAsync(
  token: string,
  id: string,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.delete(`${API_BASE_URL}/followups/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}